(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3083],{

/***/ 1379:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-home",
      function () {
        return __webpack_require__(22768);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36158);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47741);
/* harmony import */ var components_home_HomeBannerSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63695);
/* harmony import */ var components_home_HomeFeaturedCategoriesSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58920);
/* harmony import */ var components_home_HomeProductCategorySection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48444);
/* harmony import */ var components_home_HomeSingleBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77909);
/* harmony import */ var hooks_useCatchError__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(65633);
/* harmony import */ var layouts_RootLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89806);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35656);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var respository_page_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17032);
/* harmony import */ var store_product_category_store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34926);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30719);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8100);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71911);




















const SmartHomePage = (param)=>{
    let { pageProp  } = param;
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common");
    // use catch error
    const catchError = (0,hooks_useCatchError__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)();
    // init page
    const [page, setPage] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(pageProp);
    // init main slider
    const [mainSlider, setMainSlider] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    // init first banner
    const [firstBanner, setFirstBanner] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(null);
    // init spacial banner
    const [secondBanner, setSecondBanner] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(null);
    // init featuredCategories
    const [featuredCategories, setFeaturedCategories] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    // init topBottomBanner
    const [topBottomBanners, setTopBottomBanners] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    // init catalogBanners
    const [catalogBanners, setCatalogBanners] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    const [catalogBannersTop, setCatalogBannersTop] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    const [catalogBannersBottom, setCatalogBannersBottom] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    // init topBottomBanner
    const [bottomBanners, setBottomBanners] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    // set product categories to store
    const setProductCategories = (0,store_product_category_store__WEBPACK_IMPORTED_MODULE_13__/* .useProductCategoryStore */ .n)((state)=>state.setProductCategories);
    // init product category section
    const [productCategorySections, setProductCategorySections] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)([]);
    // get paage
    const { data: pageHomeData  } = (0,swr__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)("".concat("https://api.lamptan.co.th", "/v1/pages/permalink/smart-home"));
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        const getPage = async ()=>{
            try {
                // get page
                const page = await respository_page_service__WEBPACK_IMPORTED_MODULE_12__/* .PageRepository.findOneByPermalink */ .h.findOneByPermalink("smart-home");
                ;
                setPage(page);
            } catch (error) {
                catchError(error);
            }
        };
        getPage();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        if (pageHomeData) {
            setPage(pageHomeData);
        }
    }, [
        pageHomeData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        if (page) {
            if (page.customFields) {
                // ********** Main slider **********
                const mainSlider = page.customFields.find((field)=>field.key === "mainSlider");
                if (mainSlider && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(mainSlider)) {
                    const mainSliderValue = JSON.parse(mainSlider.value);
                    ;
                    setMainSlider(mainSliderValue);
                }
                // ********** First banner **********
                const firstBanner = page.customFields.find((field)=>field.key === "firstBanner");
                // if first banner
                if (firstBanner && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(firstBanner)) {
                    const firstBannerValue = JSON.parse(firstBanner.value);
                    ;
                    setFirstBanner(firstBannerValue);
                }
                // ********** Second banner **********
                const secondBanner = page.customFields.find((field)=>field.key === "secondBanner");
                // if second banner
                if (secondBanner && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(secondBanner)) {
                    const secondBannerValue = JSON.parse(secondBanner.value);
                    ;
                    setSecondBanner(secondBannerValue);
                }
                // ********** Featured categories **********
                const featuredCategories = page.customFields.find((field)=>field.key === "featuredCategories");
                // if featured categories
                if (featuredCategories && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(featuredCategories)) {
                    const featuredCategoriesValue = JSON.parse(featuredCategories.value);
                    ;
                    setFeaturedCategories(featuredCategoriesValue);
                }
                // ********** Product category section **********
                const productCategorySection = page.customFields.find((field)=>field.key === "productCategorySection");
                if (productCategorySection && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(productCategorySection)) {
                    const productCategorySectionValue = JSON.parse(productCategorySection.value);
                    setProductCategorySections(productCategorySectionValue);
                }
                // ********** Top bottom banner **********
                const topBottomBanners = page.customFields.find((field)=>field.key === "topBottomBanners");
                if (topBottomBanners && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(topBottomBanners)) {
                    const topBottomBannersValue = JSON.parse(topBottomBanners.value);
                    ;
                    setTopBottomBanners(topBottomBannersValue);
                }
                // ********** Catalog banners top **********
                const catalogBannersTop = page.customFields.find((field)=>field.key === "catalogBannersTop");
                ;
                if (catalogBannersTop && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(catalogBannersTop)) {
                    const catalogBannersTopValue = JSON.parse(catalogBannersTop.value);
                    ;
                    setCatalogBannersTop(catalogBannersTopValue);
                }
                // ********** Catalog banners **********
                const catalogBanners = page.customFields.find((field)=>field.key === "catalogs");
                if (catalogBanners && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(catalogBanners)) {
                    const catalogBannersValue = JSON.parse(catalogBanners.value);
                    ;
                    setCatalogBanners(catalogBannersValue);
                }
                // ********** Catalog banners bottom **********
                const catalogBannersBottom = page.customFields.find((field)=>field.key === "catalogBannersBottom");
                if (catalogBannersBottom && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(catalogBannersBottom)) {
                    const catalogBannersBottomValue = JSON.parse(catalogBannersBottom.value);
                    ;
                    setCatalogBannersBottom(catalogBannersBottomValue);
                }
                // ********** Bottom banner **********
                const bottomBanners = page.customFields.find((field)=>field.key === "bottomBanners");
                if (bottomBanners && !(0,lodash__WEBPACK_IMPORTED_MODULE_6__.isEmpty)(bottomBanners)) {
                    const bottomBannersValue = JSON.parse(bottomBanners.value);
                    ;
                    setBottomBanners(bottomBannersValue);
                }
            }
        }
    }, [
        page
    ]);
    var _banner_link, _banner_target, _banner_link1, _banner_target1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: page && page.name_th ? page.name_th : "Home"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://lamptan-co-th.oss-ap-southeast-7.aliyuncs.com//home/main-sliders/01-mb-home-lighting-banner-1125x455px_th.jpeg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                bg: {
                    base: "#eee",
                    lg: "#fff"
                },
                pb: 5,
                overflow: "hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                        isLoaded: mainSlider && mainSlider.length > 0,
                        children: mainSlider && mainSlider.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                            maxWidth: "1920px",
                            margin: "0 auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_14__/* .Swiper */ .tq, {
                                spaceBetween: 0,
                                slidesPerView: 1,
                                autoplay: {
                                    delay: 5000,
                                    disableOnInteraction: false
                                },
                                pagination: {
                                    clickable: true
                                },
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_17__/* .Autoplay */ .pt,
                                    swiper__WEBPACK_IMPORTED_MODULE_17__/* .Pagination */ .tl
                                ],
                                onSwiper: (swiper)=>console.log(swiper),
                                children: mainSlider.map((slider, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_14__/* .SwiperSlide */ .o5, {
                                        onClick: (e)=>{
                                            ;
                                            if (slider.link) {
                                                // log slider.link
                                                router.push(slider.link);
                                            }
                                            e.preventDefault();
                                        },
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                display: {
                                                    base: "none",
                                                    md: "block"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                    src: slider.mediaDesktop ? "".concat("https://storage.lamptan.co.th", "/").concat(slider.mediaDesktop.name) : "/images/empty-image.png",
                                                    alt: "",
                                                    width: 1920,
                                                    height: 520,
                                                    quality: 90,
                                                    style: {
                                                        width: "100%",
                                                        height: "auto"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                display: {
                                                    md: "none"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                    src: slider.mediaMobile ? "".concat("https://storage.lamptan.co.th", "/").concat(slider.mediaMobile.name) : "/images/empty-image.png",
                                                    alt: "",
                                                    width: 400,
                                                    height: 120,
                                                    quality: 90,
                                                    style: {
                                                        width: "100%",
                                                        height: "auto"
                                                    }
                                                })
                                            })
                                        ]
                                    }, index))
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .AspectRatio */ .oM, {
                            ratio: 32 / 9,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {})
                        })
                    }),
                    firstBanner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        maxWidth: "1920px",
                        margin: "0 auto",
                        children: firstBanner.mediaDesktop || firstBanner.mediaMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeSingleBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                banner: firstBanner,
                                desktopWidth: 1920,
                                desktopHeight: 520,
                                mobileWidth: 500,
                                mobileHeight: 150
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    }),
                    secondBanner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        py: {
                            base: 5,
                            lg: 10
                        },
                        pb: 2,
                        bg: "white",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                            maxW: "900px",
                            px: {
                                base: 0,
                                md: 4
                            },
                            children: secondBanner.mediaDesktop || secondBanner.mediaMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeSingleBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    banner: secondBanner,
                                    desktopWidth: 1920,
                                    desktopHeight: 520,
                                    mobileWidth: 500,
                                    mobileHeight: 150
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                        })
                    }),
                    featuredCategories && featuredCategories.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                            maxWidth: "900px",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeFeaturedCategoriesSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                featuredCategories: featuredCategories
                            })
                        })
                    }),
                    productCategorySections.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        children: productCategorySections.map((section, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeProductCategorySection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                section: section,
                                productType: "smart-home"
                            }, index))
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        my: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                            maxW: "900px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                                    mb: 6,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                        height: "180px"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .SimpleGrid */ .MI, {
                                    columns: 5,
                                    spacing: 6,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Skeleton */ .Od, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                height: "100px"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                        maxW: "900px",
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Button */ .zx, {
                            bg: "gray.700",
                            width: "100%",
                            height: "50px",
                            fontSize: "xl",
                            fontWeight: "300",
                            textTransform: "uppercase",
                            onClick: ()=>{
                                router.push("/product-categories/smart-home?productType=smart-home");
                            },
                            children: t("home:seeAll")
                        })
                    }),
                    topBottomBanners && topBottomBanners.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                                maxWidth: "900px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeBannerSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    bannerItems: topBottomBanners,
                                    columns: {
                                        base: 2,
                                        md: 3
                                    },
                                    spacing: {
                                        base: 4,
                                        md: 4,
                                        lg: 6
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 0,
                            md: 0,
                            lg: 14
                        },
                        children: [
                            catalogBanners && catalogBanners.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                mb: {
                                    base: 0,
                                    md: 0,
                                    lg: 0
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                                    maxWidth: "900px",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Heading */ .X6, {
                                            textTransform: "uppercase",
                                            fontSize: {
                                                base: "xl",
                                                md: "3xl",
                                                lg: "4xl"
                                            },
                                            fontWeight: "400",
                                            color: "primary.500",
                                            mb: 4,
                                            children: "Lamptan Catalogue"
                                        }),
                                        catalogBannersTop && catalogBannersTop.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                            mb: 6,
                                            children: catalogBannersTop.map((banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                    mb: 6,
                                                    children: banner.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_16___default()), {
                                                        href: (_banner_link = banner.link) !== null && _banner_link !== void 0 ? _banner_link : "",
                                                        target: (_banner_target = banner.target) !== null && _banner_target !== void 0 ? _banner_target : "_self",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                            src: banner.media ? "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name) : "/image-icon/empty-image.png",
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520,
                                                            style: {
                                                                width: "100%",
                                                                height: "auto"
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                            src: "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name),
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520
                                                        })
                                                    })
                                                }, index))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeBannerSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            bannerItems: catalogBanners,
                                            columns: {
                                                base: 3
                                            },
                                            spacing: {
                                                base: 3,
                                                md: 6
                                            }
                                        }),
                                        catalogBannersBottom && catalogBannersBottom.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                            mb: 6,
                                            mt: 6,
                                            children: catalogBannersBottom.map((banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                                    mb: 6,
                                                    children: banner.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_16___default()), {
                                                        href: (_banner_link1 = banner.link) !== null && _banner_link1 !== void 0 ? _banner_link1 : "",
                                                        target: (_banner_target1 = banner.target) !== null && _banner_target1 !== void 0 ? _banner_target1 : "_self",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                            src: banner.media ? "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name) : "/image-icon/empty-image.png",
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520,
                                                            style: {
                                                                width: "100%",
                                                                height: "auto"
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                            src: "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name),
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520
                                                        })
                                                    })
                                                }, index))
                                        })
                                    ]
                                })
                            }),
                            bottomBanners && bottomBanners.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .xu, {
                                mt: {
                                    base: 5,
                                    md: 8,
                                    lg: 14
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Container */ .W2, {
                                    maxWidth: "900px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_HomeBannerSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        bannerItems: bottomBanners,
                                        columns: {
                                            base: 3,
                                            md: 3
                                        },
                                        spacing: {
                                            base: 3,
                                            md: 6
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SmartHomePage.getLayout = (page)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_RootLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: page
    });
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SmartHomePage);


/***/ }),

/***/ 34926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useProductCategoryStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

const useProductCategoryStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        productCategories: [],
        productCategoriesTree: [],
        setProductCategories: (payload)=>set(()=>({
                    productCategories: payload
                })),
        setProductCategoriesTree: (payload)=>set({
                productCategoriesTree: payload
            })
    }));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,1559,2077,2883,719,9806,1465,9774,2888,179], function() { return __webpack_exec__(1379); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);